import("@/bootstrap");
